import {SidebarSponsors as SponsorsComponent} from '@github-ui/code-view-sidebar/components/SidebarSponsors'
import {useSponsorDataSuspense} from '@github-ui/repo-sponsor-button/hooks/use-sponsor-data'

interface Props {
  ownerLogin: string
  repoName: string
  isOrgOwned?: boolean
}

export function SidebarSponsors({ownerLogin, repoName, isOrgOwned}: Props) {
  const {data} = useSponsorDataSuspense({ownerLogin, repoName, isOrgOwned})

  if (!data) return null
  return <SponsorsComponent {...data} />
}
